// German for the Acceptance tab: the ladder, the move, the readiness ledger, the plan, the defect
// board, the acceptance records and every confirm. Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  // ── masthead / shell ─────────────────────────────────────────────────────
  'Acceptance': 'Abnahme',
  'no engagement selected': 'kein Auftrag ausgewählt',
  'UAT and acceptance are always scoped to one engagement': 'UAT und Abnahme beziehen sich immer auf einen Auftrag',
  'A test plan belongs to one register and one client portal. Pick an engagement in the top bar and its instrument loads here.':
    'Ein Testplan gehört zu einem Register und einem Kundenportal. Wählen Sie in der Kopfleiste einen Auftrag; sein Instrument wird hier geladen.',
  'The acceptance instrument could not be read': 'Das Abnahme-Instrument konnte nicht gelesen werden',
  'GET /api/acceptance/state did not answer.': 'GET /api/acceptance/state hat nicht geantwortet.',
  'The acceptance instrument': 'Das Abnahme-Instrument',
  'review window': 'Prüffrist',
  'working days': 'Arbeitstage',
  'working days.': 'Arbeitstage.',
  'Preview as client': 'Als Kunde ansehen',

  // ── the ladder ───────────────────────────────────────────────────────────
  'Everything on this tab is discharged.': 'Alles auf diesem Tab ist erledigt.',
  'Step {n} of {total}.': 'Schritt {n} von {total}.',
  'The two gates this tab clears:': 'Die zwei Gates, die dieser Tab freigibt:',
  'of': 'von',
  'the gate engine did not answer': 'die Gate-Engine hat nicht geantwortet',
  'First unmet — {label}: {detail}.': 'Erste unerfüllte Bedingung — {label}: {detail}.',
  'Lifecycle →': 'Lebenszyklus →',

  // ── the move ─────────────────────────────────────────────────────────────
  'Next move': 'Nächster Zug',
  '{n} other thing standing on this tab': '{n} weiterer Punkt auf diesem Tab',
  '{n} other things standing on this tab': '{n} weitere Punkte auf diesem Tab',
  'Ready the plan': 'Plan bereitstellen',
  'names every write, and every condition it will not touch, before it makes any':
    'nennt jeden Schreibvorgang und jede Bedingung, die unberührt bleibt, bevor etwas geschrieben wird',
  'Issue the deemed-acceptance notice': 'Anzeige der stillschweigenden Abnahme ausstellen',
  'Read the record first': 'Zuerst das Protokoll lesen',
  "from the scheduler's task on": 'aus der Aufgabe des Schedulers zu',
  'raised‖ago': 'erstellt vor',
  'days ago': 'Tagen',
  'Move {ref} to {state}': '{ref} auf {state} setzen',
  'Open the board': 'Board öffnen',
  'Compose a record': 'Protokoll erstellen',
  'Write the test cases →': 'Testfälle schreiben →',
  "the Register's test-case tab, where a criterion becomes something a person can run":
    'der Testfall-Tab des Registers, wo aus einem Kriterium etwas wird, das eine Person ausführen kann',
  'See the plan': 'Plan ansehen',
  'Open the record': 'Protokoll öffnen',

  // ── zones ────────────────────────────────────────────────────────────────
  'The plan': 'Der Plan',
  'Defects': 'Mängel',
  'The record': 'Das Protokoll',

  // ── readiness ledger ─────────────────────────────────────────────────────
  'The plan is reachable —': 'Der Plan ist erreichbar —',
  'test cases, published and live for {client}.': 'Testfälle, veröffentlicht und live für {client}.',
  'Portal on': 'Portal aktiv',
  'invited': 'eingeladen',
  'matrix open on test cases, criteria and defects.': 'Matrix offen für Testfälle, Kriterien und Mängel.',
  'Before the client can run this': 'Bevor der Kunde das ausführen kann',
  'conditions unmet': 'Bedingungen unerfüllt',
  'not applicable': 'nicht anwendbar',
  'clear': 'erfüllt',
  'The same control as the card above — one confirm,': 'Dasselbe Steuerelement wie auf der Karte oben — eine Bestätigung,',
  'writes, no page changes. The portal switch and the linter row are not in it: who may see this engagement, and whether a criterion is testable at all, are judgements, not flags a batch can flip.':
    'Schreibvorgänge, kein Seitenwechsel. Der Portal-Schalter und die Linter-Zeile sind nicht enthalten: Wer diesen Auftrag sehen darf und ob ein Kriterium überhaupt testbar ist, sind Ermessensentscheide, keine Flags, die ein Stapel umlegen kann.',

  // ── the plan ─────────────────────────────────────────────────────────────
  'test cases': 'Testfälle',
  'runnable': 'ausführbar',
  'run‖done': 'ausgeführt',
  'pass': 'bestanden',
  'fail': 'nicht bestanden',
  'blocked': 'blockiert',
  'not run': 'nicht ausgeführt',
  'NOT RUN': 'NICHT AUSGEFÜHRT',
  'Everything in the engagement': 'Alles im Auftrag',
  '{n} deliverable': '{n} Arbeitsergebnis',
  '{n} deliverables': '{n} Arbeitsergebnisse',
  'This milestone carries no deliverables': 'Dieser Meilenstein trägt keine Arbeitsergebnisse',
  '“{name}” has nothing mapped to it, so there is nothing to test': '«{name}» ist nichts zugeordnet, also gibt es nichts zu testen',
  'under this filter': 'unter diesem Filter',
  '. The engagement has': '. Der Auftrag hat',
  'elsewhere and': 'an anderer Stelle und',
  '{n} recorded run': '{n} erfassten Lauf',
  '{n} recorded runs': '{n} erfasste Läufe',
  '— the filter is hiding them, not the register.': '— der Filter verbirgt sie, nicht das Register.',
  'This milestone': 'Dieser Meilenstein',
  'Show everything in the engagement': 'Alles im Auftrag anzeigen',
  'Nothing to test yet': 'Noch nichts zu testen',
  'A plan needs a deliverable, a requirement mapped to it, an acceptance criterion on that requirement and a test case against the criterion. This engagement has':
    'Ein Plan braucht ein Arbeitsergebnis, eine ihm zugeordnete Anforderung, ein Abnahmekriterium an dieser Anforderung und einen Testfall zu diesem Kriterium. Dieser Auftrag hat',
  'acceptance criteria and': 'Abnahmekriterien und',
  'test cases on record.': 'Testfälle erfasst.',
  'Open the Register →': 'Register öffnen →',
  'published': 'veröffentlicht',
  'unpublished': 'unveröffentlicht',
  'planned': 'geplant',
  'in_progress': 'in Arbeit',
  'delivered': 'geliefert',
  'accepted': 'abgenommen',
  'dropped': 'verworfen',
  'None of these criteria is reachable by {client} — the reasons are the': 'Keines dieser Kriterien ist für {client} erreichbar — die Gründe sind die',
  'conditions above, not anything on these rows.': 'Bedingungen oben, nicht etwas in diesen Zeilen.',
  'No test case exists on this engagement at all, so there is nothing for the client to press pass or fail on.':
    'Auf diesem Auftrag existiert überhaupt kein Testfall, also gibt es nichts, worauf der Kunde «bestanden» oder «nicht bestanden» drücken könnte.',
  'Read them here as the register, not as a plan that is live.': 'Lesen Sie sie hier als Register, nicht als einen Plan, der live ist.',
  'No requirement is mapped to this deliverable — unjustified work.': 'Diesem Arbeitsergebnis ist keine Anforderung zugeordnet — unbegründete Arbeit.',
  'No acceptance criterion — nothing to test, and nothing a defect could cite.': 'Kein Abnahmekriterium — nichts zu testen, und nichts, worauf sich ein Mangel berufen könnte.',
  'no test': 'kein Test',
  'draft': 'Entwurf',
  'criterion hidden': 'Kriterium verborgen',
  '— nothing recorded': '— nichts erfasst',
  'Raise defect': 'Mangel melden',
  'Record a run': 'Lauf erfassen',

  // ── recorded runs ────────────────────────────────────────────────────────
  'Recorded runs': 'Erfasste Läufe',
  'recorded': 'erfasst',
  'latest': 'zuletzt',
  'nothing recorded': 'nichts erfasst',
  'No result has been recorded': 'Es wurde kein Ergebnis erfasst',
  'Results land here the moment the client records them in the portal — or the moment you record one yourself from a witnessed session, using the control on each criterion above.':
    'Ergebnisse erscheinen hier, sobald der Kunde sie im Portal erfasst — oder sobald Sie selbst eines aus einer beobachteten Sitzung erfassen, über das Steuerelement an jedem Kriterium oben.',
  'Results land here the moment the client records them in the portal — or the moment you record one yourself from a witnessed session. Right now neither can happen: the plan is not reachable, so the portal shows the client nothing to run.':
    'Ergebnisse erscheinen hier, sobald der Kunde sie im Portal erfasst — oder sobald Sie selbst eines aus einer beobachteten Sitzung erfassen. Im Moment ist beides nicht möglich: Der Plan ist nicht erreichbar, das Portal zeigt dem Kunden also nichts zum Ausführen.',
  'Back to step 1': 'Zurück zu Schritt 1',
  'Test': 'Test',
  'Note the tester left': 'Notiz des Testers',
  'Result': 'Ergebnis',
  'By': 'Von',
  'When': 'Wann',
  'Evidence': 'Belege',
  'portal': 'Portal',
  'operator': 'Operator',
  'attachment': 'Anhang',

  // ── defect board ─────────────────────────────────────────────────────────
  'Defect board': 'Mängel-Board',
  'open': 'offen',
  'blocking or major': 'blockierend oder schwer',
  'oldest': 'ältester',
  'days': 'Tage',
  'nothing raised': 'nichts gemeldet',
  'No defect has been raised': 'Es wurde kein Mangel gemeldet',
  'A defect must cite the acceptance criterion it violates — that constraint is in the schema, not the form. If nothing agreed was broken, the honest instrument is a change request.':
    'Ein Mangel muss das Abnahmekriterium nennen, das er verletzt — diese Regel steckt im Schema, nicht im Formular. Wenn nichts Vereinbartes gebrochen wurde, ist das ehrliche Instrument ein Änderungsantrag.',
  'Right now the client cannot raise one either:': 'Im Moment kann auch der Kunde keinen melden:',
  'criteria are unpublished, so their form has nothing to select.': 'Kriterien sind unveröffentlicht, sein Formular hat also nichts zur Auswahl.',
  'Open the plan to raise one from a failing run': 'Plan öffnen, um einen aus einem fehlgeschlagenen Lauf zu melden',
  'Severity definitions —': 'Schweregrad-Definitionen —',
  ', the wording that goes in the record': ', der Wortlaut, der ins Protokoll kommt',
  'blocking': 'blockierend',
  'major': 'schwer',
  'minor': 'gering',
  'in fix': 'in Behebung',
  'fixed': 'behoben',
  'verified': 'verifiziert',
  'closed': 'geschlossen',
  'withdrawn': 'zurückgezogen',
  'agreed fix': 'vereinbarte Behebung',
  '{n}d past': '{n} T. überfällig',
  '{n}d out': 'in {n} T.',
  'no fix date agreed': 'kein Behebungsdatum vereinbart',
  'the criterion this violates': 'das Kriterium, das verletzt wird',
  'from': 'aus',
  'raised by {who}': 'gemeldet von {who}',
  'Move to {state}': 'Auf {state} setzen',
  'Status': 'Status',
  'Status of {ref}': 'Status von {ref}',
  '{ref} moved to {state}': '{ref} auf {state} gesetzt',
  'Severity': 'Schweregrad',
  'Severity of {ref}': 'Schweregrad von {ref}',
  'Agreed fix': 'Vereinbarte Behebung',
  'Agreed fix date on {ref}': 'Vereinbartes Behebungsdatum von {ref}',
  'Fix date on {ref} recorded': 'Behebungsdatum von {ref} erfasst',
  'Not an AC violation after all — raise it as a change request instead': 'Doch keine Verletzung eines Abnahmekriteriums — stattdessen als Änderungsantrag stellen',
  'To change request': 'In Änderungsantrag',
  'Delete this defect — for a duplicate or a row raised by mistake': 'Diesen Mangel löschen — für ein Duplikat oder eine irrtümlich erstellte Zeile',
  'Delete': 'Löschen',

  // ── the record zone ──────────────────────────────────────────────────────
  'Operator task': 'Operator-Aufgabe',
  'raised by the scheduler': 'vom Scheduler erstellt',
  'days ago. The control is the one at the top of the page.': 'Tage her. Das Steuerelement dafür steht oben auf der Seite.',
  'Deliverable coverage': 'Abdeckung der Arbeitsergebnisse',
  'G5 condition 2 — every deliverable must sit on an issued record': 'G5 Bedingung 2 — jedes Arbeitsergebnis muss auf einem ausgestellten Protokoll stehen',
  'No deliverable is defined': 'Kein Arbeitsergebnis definiert',
  'G5 asks whether every deliverable sits on an issued acceptance record. With none defined there is nothing to cover, and the gate stays shut on its first condition.':
    'G5 fragt, ob jedes Arbeitsergebnis auf einem ausgestellten Abnahmeprotokoll steht. Ohne definierte Arbeitsergebnisse gibt es nichts abzudecken, und das Gate bleibt an seiner ersten Bedingung geschlossen.',
  'on {refs} ({status})': 'auf {refs} ({status})',
  'on no issued record — G5 cannot clear': 'auf keinem ausgestellten Protokoll — G5 kann nicht freigeben',
  'issued': 'ausgestellt',
  'signed': 'unterzeichnet',
  'deemed_notice_issued': 'stillschweigende Abnahme angezeigt',
  'Acceptance records': 'Abnahmeprotokolle',
  'record': 'Protokoll',
  'records': 'Protokolle',
  'awaiting the sponsor': 'warten auf den Sponsor',
  'none composed': 'keines erstellt',
  'No acceptance record has been composed': 'Es wurde kein Abnahmeprotokoll erstellt',
  'A record is generated from the register: the deliverables covered, every test result, every open defect with its agreed fix date, the severity definitions the client signed up to, and your exclusions. Composing one now would print':
    'Ein Protokoll wird aus dem Register erzeugt: die abgedeckten Arbeitsergebnisse, jedes Testergebnis, jeder offene Mangel mit seinem vereinbarten Behebungsdatum, die Schweregrad-Definitionen, denen der Kunde zugestimmt hat, und Ihre Ausschlüsse. Jetzt eines zu erstellen würde',
  "tests with no result — which is exactly what the composer's warnings would say.": 'Tests ohne Ergebnis ausdrucken — genau das, was die Warnungen des Editors sagen würden.',

  // ── one record ───────────────────────────────────────────────────────────
  'window closed': 'Prüffrist abgelaufen',
  'with the sponsor': 'beim Sponsor',
  'deemed notice': 'stillschweigende Abnahme angezeigt',
  '— no milestone —': '— kein Meilenstein —',
  '{n}d overdue': '{n} T. überfällig',
  '{n}d left': 'noch {n} T.',
  'window': 'Prüffrist',
  'closes': 'endet',
  'The ball is': 'Der Ball liegt',
  'and has been for': 'und zwar seit',
  'days.': 'Tagen.',
  'The window closed': 'Die Prüffrist ist seit',
  'days ago and Signet raised a task rather than accepting anything.': 'Tagen abgelaufen, und Signet hat eine Aufgabe erstellt, statt etwas abzunehmen.',
  'Nothing here needs you until it closes.': 'Bis sie endet, braucht es Sie hier nicht.',
  'A draft: nothing has reached the client and no window is running. Issuing publishes it and starts the review clock.':
    'Ein Entwurf: Nichts hat den Kunden erreicht, und keine Prüffrist läuft. Das Ausstellen veröffentlicht ihn und startet die Prüffrist.',
  'Withdrawn — unpublished from the portal and kept on the record (P4).': 'Zurückgezogen — im Portal zurückgenommen und in den Akten behalten (P4).',
  'No review window is recorded on this record.': 'Auf diesem Protokoll ist keine Prüffrist erfasst.',
  'Deliverables covered': 'Abgedeckte Arbeitsergebnisse',
  'none': 'keine',
  'Published to the portal': 'Im Portal veröffentlicht',
  'yes': 'ja',
  'no': 'nein',
  'Signature': 'Unterschrift',
  '— unsigned': '— nicht unterzeichnet',
  'Content hash': 'Inhalts-Hash',
  'Read the record': 'Protokoll lesen',
  'Re-run the composer over the current test results and defect board, keeping this ref': 'Den Editor über die aktuellen Testergebnisse und das Mängel-Board neu laufen lassen, die Ref bleibt',
  'Refresh': 'Aktualisieren',
  'Issue': 'Ausstellen',
  'Deemed notice': 'Stillschweigende Abnahme',
  'Discard draft': 'Entwurf verwerfen',
  'Withdraw': 'Zurückziehen',

  // ── the composer ─────────────────────────────────────────────────────────
  'Compose an acceptance record': 'Abnahmeprotokoll erstellen',
  'The document is generated from the register — it is not written by hand.': 'Das Dokument wird aus dem Register erzeugt — es wird nicht von Hand geschrieben.',
  'These sentences will be printed in the document': 'Diese Sätze werden im Dokument gedruckt',
  'Composing is still allowed — a record that states its own qualifications is the point. But the sponsor reads them.':
    'Erstellen ist trotzdem erlaubt — ein Protokoll, das seine eigenen Vorbehalte nennt, ist der Sinn der Sache. Aber der Sponsor liest sie.',
  'The preview could not be rendered': 'Die Vorschau konnte nicht erzeugt werden',
  'The preview could not be rendered.': 'Die Vorschau konnte nicht erzeugt werden.',
  'Milestone': 'Meilenstein',
  'due {date}': 'fällig {date}',
  "Preview to pull in the milestone's deliverables.": 'Vorschau erzeugen, um die Arbeitsergebnisse des Meilensteins zu laden.',
  'Exclusions and qualifications': 'Ausschlüsse und Vorbehalte',
  'e.g. Excludes the OCR pipeline (DEL-04) — deferred to phase 2 by agreement of 21.05.2026.': 'z. B. Ohne die OCR-Pipeline (DEL-04) — gemäss Vereinbarung vom 21.05.2026 auf Phase 2 verschoben.',
  'What the document will say': 'Was im Dokument stehen wird',
  'None selected.': 'Keines ausgewählt.',
  'Test results': 'Testergebnisse',
  'No test case is in scope.': 'Kein Testfall im Umfang.',
  'Open defects': 'Offene Mängel',
  'None.': 'Keine.',
  'Severity definitions': 'Schweregrad-Definitionen',
  '{n} definition': '{n} Definition',
  '{n} definitions': '{n} Definitionen',
  'the definitions did not load': 'die Definitionen wurden nicht geladen',
  'not read': 'nicht gelesen',
  'Footer': 'Fusszeile',
  'Signing accepts the deliverables listed above, subject to the open defects and their agreed fix dates.':
    'Mit der Unterschrift werden die oben aufgeführten Arbeitsergebnisse abgenommen, vorbehaltlich der offenen Mängel und ihrer vereinbarten Behebungsdaten.',
  'Draft only — nothing reaches the client until you issue it.': 'Nur ein Entwurf — nichts erreicht den Kunden, bis Sie es ausstellen.',
  'Re-read the register': 'Register neu lesen',
  'Cancel': 'Abbrechen',
  'Create the draft': 'Entwurf erstellen',
  'Create the draft anyway': 'Entwurf trotzdem erstellen',

  // ── raise a defect ───────────────────────────────────────────────────────
  'Raise a defect': 'Mangel melden',
  'A defect must cite the acceptance criterion it violates. If nothing agreed was broken, it is a change request.':
    'Ein Mangel muss das Abnahmekriterium nennen, das er verletzt. Wenn nichts Vereinbartes gebrochen wurde, ist es ein Änderungsantrag.',
  'The criterion it violates — fixed by the failing run, not chosen from a list': 'Das verletzte Kriterium — durch den fehlgeschlagenen Lauf festgelegt, nicht aus einer Liste gewählt',
  'Title': 'Titel',
  'Description': 'Beschreibung',
  'What each severity commits you to': 'Wozu Sie jeder Schweregrad verpflichtet',
  'Agreed fix date': 'Vereinbartes Behebungsdatum',
  'This is new scope → change request': 'Das ist neuer Umfang → Änderungsantrag',
  'A title of at least 5 characters is required — the server refuses less.': 'Ein Titel mit mindestens 5 Zeichen ist erforderlich — der Server lehnt weniger ab.',
  'Raise the defect': 'Mangel melden',

  // ── modals ───────────────────────────────────────────────────────────────
  'Acceptance record': 'Abnahmeprotokoll',
  'The artefact itself — the HTML that is hashed, stored and signed. It is deliberately not restyled here.':
    'Das Artefakt selbst — das HTML, das gehasht, gespeichert und unterzeichnet wird. Es wird hier bewusst nicht umgestaltet.',
  'Ready the plan for the client': 'Plan für den Kunden bereitstellen',
  'This makes': 'Dies führt',
  'write': 'Schreibvorgang',
  'writes': 'Schreibvorgänge',
  "in one transaction. Every one is reversible from the Client Portal page; none of them touches the register's content.":
    'in einer Transaktion aus. Jeder ist über die Seite «Kundenportal» umkehrbar; keiner berührt den Inhalt des Registers.',
  'Will write': 'Wird schreiben',
  'Will not touch': 'Bleibt unberührt',
  'engagements.portal_enabled and the invite: deciding who may see this engagement is a grant decision':
    'engagements.portal_enabled und die Einladung: Wer diesen Auftrag sehen darf, ist eine Berechtigungsentscheidung',
  'nothing — whether a criterion is testable at all is a judgement, not a toggle': 'nichts — ob ein Kriterium überhaupt testbar ist, ist ein Ermessensentscheid, kein Schalter',
  "The client's view moves along two axes at once: marking a test case ready and publishing it both change what the portal's UAT list counts. Nothing that is still draft will be published.":
    'Die Sicht des Kunden bewegt sich entlang zweier Achsen zugleich: Einen Testfall als bereit zu markieren und ihn zu veröffentlichen verändert beides, was die UAT-Liste des Portals zählt. Nichts, das noch Entwurf ist, wird veröffentlicht.',
  'Move': 'Setzen',
  '{ref} is': '{ref} ist',
  'and {severity}.': 'und {severity}.',
  'Moving it to': 'Wird er auf',
  'takes it OFF the blocking count —': 'gesetzt, zählt er NICHT MEHR als blockierend —',
  'may open as a result.': 'kann sich dadurch öffnen.',
  'does not clear': 'gesetzt, öffnet das',
  '— only': 'nicht — nur',
  'or': 'oder',
  'takes it off the blocking count.': 'nimmt ihn aus der Blockierzählung.',
  '{from} → {to} on {ref}': '{from} → {to} auf {ref}',
  'an audit row with the before and after': 'eine Audit-Zeile mit Vorher und Nachher',
  'Change {ref} to {severity}': '{ref} auf {severity} ändern',
  'Change the severity': 'Schweregrad ändern',
  '{ref} is now {severity}': '{ref} ist jetzt {severity}',
  'Severity is a commitment, not a label.': 'Der Schweregrad ist eine Verpflichtung, kein Etikett.',
  'counts': 'zählt',
  'blocking and major': 'blockierende und schwere',
  'defects that are not closed, verified or withdrawn — so': 'Mängel, die nicht geschlossen, verifiziert oder zurückgezogen sind — also',
  'CLOSES the gate that may be open now.': 'SCHLIESST das Gate, das jetzt vielleicht offen ist.',
  'OPENS a gate this defect is currently holding shut.': 'ÖFFNET ein Gate, das dieser Mangel derzeit geschlossen hält.',
  'leaves the gate count unchanged.': 'lässt die Gate-Zählung unverändert.',
  'The definition the client signed up to is the wording in the record, not this dropdown.': 'Die Definition, der der Kunde zugestimmt hat, ist der Wortlaut im Protokoll, nicht dieses Auswahlfeld.',
  'Record a witnessed run on {ref}': 'Beobachteten Lauf zu {ref} erfassen',
  'Record the run': 'Lauf erfassen',
  'You watched this test run. The row is attributed to': 'Sie haben diesen Testlauf beobachtet. Die Zeile wird',
  'you‖dative': 'Ihnen',
  'as an operator-witnessed run — the runs table renders': 'als vom Operator beobachteter Lauf zugeschrieben — die Läufe-Tabelle zeigt',
  ', so it can never be mistaken for one the client executed. That distinction is the evidentiary value; it ends up inside a hashed record.':
    ', sodass er nie mit einem vom Kunden ausgeführten Lauf verwechselt werden kann. Diese Unterscheidung ist der Beweiswert; sie landet in einem gehashten Protokoll.',
  'What you observed': 'Was Sie beobachtet haben',
  'e.g. Walked section 4 with Asbjorn on 5 August; all six headings present.': 'z. B. Abschnitt 4 am 5. August mit Asbjorn durchgegangen; alle sechs Überschriften vorhanden.',
  'Issue {ref}': '{ref} ausstellen',
  'Issue to the client': 'An den Kunden ausstellen',
  'Issuing publishes the record to the portal and starts the review window. Leave the date empty to use':
    'Das Ausstellen veröffentlicht das Protokoll im Portal und startet die Prüffrist. Lassen Sie das Datum leer, um die Prüffrist von',
  "'s review window of": 'zu verwenden —',
  'Review deadline (optional)': 'Prüffrist-Ende (optional)',
  'On expiry Signet raises an operator task. It never accepts anything on its own.': 'Bei Ablauf erstellt Signet eine Operator-Aufgabe. Es nimmt nie von sich aus etwas ab.',
  'Deemed-acceptance notice — {ref}': 'Anzeige der stillschweigenden Abnahme — {ref}',
  'Issue the notice': 'Anzeige ausstellen',
  'The review window closed': 'Die Prüffrist ist am',
  'with no signature. The notice is appended to the record and its hash re-computed; the sponsor can still counter-sign afterwards.':
    'ohne Unterschrift abgelaufen. Die Anzeige wird dem Protokoll angehängt und der Hash neu berechnet; der Sponsor kann danach weiterhin gegenzeichnen.',
  'the notice text into': 'den Text der Anzeige in',
  ', hash re-computed': ', Hash neu berechnet',
  'the milestone and its deliverables → accepted': 'den Meilenstein und seine Arbeitsergebnisse → abgenommen',
  'the operator task closed': 'die Operator-Aufgabe geschlossen',
  'Read this first': 'Lesen Sie das zuerst',
  'The document still lists': 'Das Dokument führt noch',
  'open blocking or major defect': 'offenen blockierenden oder schweren Mangel auf',
  'open blocking or major defects': 'offene blockierende oder schwere Mängel auf',
  'The notice says the deliverable is treated as accepted': 'Die Anzeige besagt, dass das Arbeitsergebnis als abgenommen gilt',
  'subject to': 'vorbehaltlich',
  'that defect and its agreed fix date. If that is not the position you want on the record, close the defect first and recompose.':
    'dieses Mangels und seines vereinbarten Behebungsdatums. Wenn das nicht die Position ist, die Sie im Protokoll wollen, schliessen Sie zuerst den Mangel und erstellen Sie es neu.',
  'Note for the record (optional)': 'Notiz fürs Protokoll (optional)',
  'e.g. Called the sponsor on 5 August; no objection raised.': 'z. B. Sponsor am 5. August angerufen; kein Einwand erhoben.',
  'Withdraw {ref}?': '{ref} zurückziehen?',
  'The record is unpublished from the portal and kept as': 'Das Protokoll wird im Portal zurückgenommen und behalten als',
  '— it is never deleted (P4). Use this when the facts moved after issue: withdraw, compose a fresh record, issue that.':
    '— es wird nie gelöscht (P4). Verwenden Sie dies, wenn sich die Fakten nach dem Ausstellen geändert haben: zurückziehen, ein neues Protokoll erstellen, dieses ausstellen.',
  'Discard draft {ref}?': 'Entwurf {ref} verwerfen?',
  'Discard': 'Verwerfen',
  'This draft was never issued, so the client has never seen it and nothing leaves the record. If it is only out of date,':
    'Dieser Entwurf wurde nie ausgestellt; der Kunde hat ihn also nie gesehen, und nichts verlässt die Akten. Wenn er nur veraltet ist,',
  'recomposes it against the current facts and keeps the ref.': 'erstellt ihn gegen die aktuellen Fakten neu und behält die Ref.',
  'Convert {ref} to a change request': '{ref} in einen Änderungsantrag umwandeln',
  'Convert': 'Umwandeln',
  'The defect is withdrawn (never deleted) with a link note, and a draft change request is created carrying its description. Use this when nothing agreed was actually broken.':
    'Der Mangel wird mit einer Verknüpfungsnotiz zurückgezogen (nie gelöscht), und ein Änderungsantrag im Entwurf wird mit seiner Beschreibung erstellt. Verwenden Sie dies, wenn tatsächlich nichts Vereinbartes gebrochen wurde.',
  'Triage note': 'Triage-Notiz',
  'e.g. Column order was never in an acceptance criterion — this is new scope.': 'z. B. Die Spaltenreihenfolge stand nie in einem Abnahmekriterium — das ist neuer Umfang.',
  'Delete {ref}?': '{ref} löschen?',
  'Deleting…': 'Wird gelöscht…',
  'Delete permanently': 'Endgültig löschen',
  'Immediate and permanent — this is for a defect that should never have been raised (a duplicate of the same failing run, a test row). If it was real and simply is not a defect after all, set it to':
    'Sofort und endgültig — das ist für einen Mangel, der nie hätte gemeldet werden sollen (ein Duplikat desselben fehlgeschlagenen Laufs, eine Testzeile). War er echt und ist nur doch kein Mangel, setzen Sie ihn auf',
  'or convert it to a change request: both keep the triage decision on the record. The audit log keeps the deleted row.':
    'oder wandeln Sie ihn in einen Änderungsantrag um: Beides behält den Triage-Entscheid in den Akten. Das Audit-Log behält die gelöschte Zeile.',
  '{ref} cannot be deleted': '{ref} kann nicht gelöscht werden',
  'Nothing else points at it — the row goes on its own.': 'Nichts anderes verweist darauf — die Zeile geht allein.',
  'This also removes:': 'Dies entfernt auch:',
  'Understood': 'Verstanden',
  'Open the Client Portal page': 'Seite «Kundenportal» öffnen',
  'The portal is open and the plan is reachable:': 'Das Portal ist offen und der Plan erreichbar:',
  'test cases,': 'Testfälle,',
  'published criteria and the defect form. The preview link itself is minted on the Client Portal page, which is where the grant it bypasses is administered.':
    'veröffentlichte Kriterien und das Mängel-Formular. Der Vorschau-Link selbst wird auf der Seite «Kundenportal» erzeugt, wo auch die Berechtigung verwaltet wird, die er umgeht.',
  'The portal is': 'Das Portal ist',
  'on‖state': 'aktiv',
  'off': 'inaktiv',
  'for': 'für',
  'and': 'und',
  'people are invited. A preview would show an empty shell — which is accurate, and is the point of step 1.':
    'Personen sind eingeladen. Eine Vorschau würde eine leere Hülle zeigen — was zutrifft und der Sinn von Schritt 1 ist.',

  // ── toasts ───────────────────────────────────────────────────────────────
  'Could not update the defect': 'Der Mangel konnte nicht aktualisiert werden',
  'The batch could not be written': 'Der Stapel konnte nicht geschrieben werden',
  'Defect raised against {ref}': 'Mangel zu {ref} gemeldet',
  'Could not raise the defect': 'Der Mangel konnte nicht gemeldet werden',
  'Could not record the run': 'Der Lauf konnte nicht erfasst werden',
  'Could not work out what deleting this defect would do': 'Es liess sich nicht ermitteln, was das Löschen dieses Mangels bewirken würde',
  '{ref} deleted': '{ref} gelöscht',
  'Could not delete the defect': 'Der Mangel konnte nicht gelöscht werden',
  'Could not convert the defect': 'Der Mangel konnte nicht umgewandelt werden',
  '{ref} composed as a draft': '{ref} als Entwurf erstellt',
  'Could not compose the record': 'Das Protokoll konnte nicht erstellt werden',
  'Could not issue the record': 'Das Protokoll konnte nicht ausgestellt werden',
  'Deemed-acceptance notice issued on {ref}': 'Anzeige der stillschweigenden Abnahme zu {ref} ausgestellt',
  'Could not issue the notice': 'Die Anzeige konnte nicht ausgestellt werden',
  'Could not recompose the record': 'Das Protokoll konnte nicht neu erstellt werden',
  '{ref} withdrawn — unpublished from the portal': '{ref} zurückgezogen — im Portal zurückgenommen',
  'Could not withdraw the record': 'Das Protokoll konnte nicht zurückgezogen werden',
  'Draft {ref} discarded': 'Entwurf {ref} verworfen',
  'Could not delete the draft': 'Der Entwurf konnte nicht gelöscht werden',
}, 'AcceptancePage');
